import http from "@/settings/apiSettings"

export interface PlanificareAppointment {
  ID?: number;
  EmployeesID?: string;
  Text: string;
  Description?: string;
  StartDate: string;
  EndDate: string;
  AllDay: boolean;
  RecurrenceRule?: string;
}

class PORTAL_PlanificareAnualaService {
  getPlan(an: number): Promise<any> {
    return http.clientPortalHR.get("/portal/planificare", {
      params: { an },
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  create(dto: PlanificareAppointment): Promise<any> {
    return http.clientPortalHR.post("/portal/planificare", dto, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  update(id: number, dto: PlanificareAppointment): Promise<any> {
    return http.clientPortalHR.put(`/portal/planificare/${id}`, dto, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  remove(id: number): Promise<any> {
    return http.clientPortalHR.delete(`/portal/planificare/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getPlanificareDepartament(structId: string, an: number): Promise<any> {
    return http.clientPortalHR.get("/portal/planificare-departament", {
      params: { structId, an },
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_PlanificareAnualaService();
